import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import getEnterpriseGroupBuyStoreAndItems, {
  Result,
} from '~/firebase/get/getEnterpriseGroupBuyStoreAndItems';
import { enterpriseGroupBuyStoresMapListener } from '~/firebase/listeners/enterpriseGroupBuyStoresMap';
import { EnterpriseGroupBuyStore } from '~/types/enterpriseGroupBuy';
import { FetchingDataStatus } from '~/types/utilities';

export default function useEnterpriseGroupBuyStoreList(pickMealAt: Date | null) {
  const { enterpriseGroupBuyId = '' } = useParams();
  const [fetchingStatus, setFetchingStatus] = useState<FetchingDataStatus>(FetchingDataStatus.INIT);
  const [storesMap, setStoresMap] = useState<Map<string, EnterpriseGroupBuyStore>>(new Map([]));
  const [storeList, setStores] = useState<Array<Result>>([]);

  useEffect(() => {
    if (!!enterpriseGroupBuyId) {
      const unlisten = enterpriseGroupBuyStoresMapListener(enterpriseGroupBuyId, setStoresMap);

      return () => {
        unlisten();
      };
    }
  }, [enterpriseGroupBuyId]);

  const handleFetchStoresList = useCallback(
    async (storesMap: Map<string, EnterpriseGroupBuyStore>) => {
      if (!pickMealAt) return;
      try {
        setFetchingStatus(FetchingDataStatus.LOADING);
        const d = await getEnterpriseGroupBuyStoreAndItems(storesMap, pickMealAt);

        setFetchingStatus(FetchingDataStatus.SUCCESS);
        setStores(d);
      } catch (err) {
        console.log('handleFetchStoresList error', err);
        setFetchingStatus(FetchingDataStatus.FAIL);
      }
    },
    [setStores, setFetchingStatus, pickMealAt],
  );

  useEffect(() => {
    if (storesMap.size <= 0) {
      setStores([]);
      return;
    }

    handleFetchStoresList(storesMap);
  }, [JSON.stringify(storesMap), handleFetchStoresList]);

  return { storeList, fetchingStatus };
}
